module.exports = __webpack_public_path__ + "static/media/cpf-person-campanha.77674740.png";